<template>
	<Transition name="fade">
		<div v-if="visibleId" class="sem-wrapper">
			<div class="sem">

				<div class="sem-center" v-if="error">
					<ErrorSplash :message="error.statusText" :status="error.status" />
				</div>

				<div class="sem-center" v-if="loading">
					<div class="loading-splash">
						<h1 class="title">Loading...</h1>
						<div class="content">Page is loading, maybe a gif here?</div>
					</div>
				</div>

				<div class="sem-col" v-if="event">
					<event-picture :image="event.vue_events_plugin_images" :alt="event.title.rendered"
						:classes="['vue-events-plugin-single-image mb-3']"></event-picture>
					<p v-if="event.vue_events_plugin_event_start_date && event.vue_events_plugin_event_start_date.rendered"
						class="fw-bold">Starts: {{ event.vue_events_plugin_event_start_date.rendered }}</p>
					<p v-if="event.vue_events_plugin_event_end_date && event.vue_events_plugin_event_end_date.rendered"
						class="fw-bold">Ends: {{ event.vue_events_plugin_event_end_date.rendered }}</p>
					<h1 v-html="event.title.rendered"></h1>
					<small>Post ID #{{ event.id }}</small>
					<div class="content" v-html="event.content.rendered">
					</div>
				</div>

			</div>
			<div class="sem-grey-over" @click="close">
				<button type="button" class="btn btn-close btn-close-white" aria-label="Close" @click="close"></button>
			</div>
		</div><!-- .sem-wrapper -->
	</Transition>
</template>

<script>
import { get } from '@/services/EventsGetter'
import ErrorSplash from '@/components/ErrorSplash.vue';
import EventPicture from '@/components/EventPicture.vue';

export default {
	name: 'SingleEventModal',
	components: {
		ErrorSplash,
		EventPicture
	},
	props: {
		visibleId: {
			required: false,
			type: Number,
		}
	},
	emits: ['closeModal'],
	data() {
		return {
			loading: true,
			event: null,
			error: null,
		}
	},
	methods: {
		reset() {
			this.error = null
			this.event = null
			this.loading = true
		},
		async loadEvent(eventId = null) {
			// Reset to empty old event data
			this.reset()

			if (!eventId) {
				eventId = this.visibleId
			}

			// Make a new REST request
			const response = await get(eventId)

			// Stop on error
			if (200 !== response.status) {
				this.error = response
				this.loading = false
				this.event = null
				return
			}

			// Update class event data
			this.event = response.data
			this.loading = false
		},
		close() {
			this.$emit('closeModal')
			return false
		}
	},
	watch: {
		visibleId() {
			this.loadEvent(this.visibleId)
		}
	}
}
</script>

<style scoped lang="scss">
.sem-grey-over {
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.4);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	z-index: 99;
}

.btn-close {
	position: absolute;
	top: 1rem;
	right: 1rem;
	border: 1px solid #FFF;
	border-radius: 50%;
	padding: 0.7rem;
}

.sem {
	position: fixed;
	z-index: 100;
	width: 75vw;
	height: 75vh;
	overflow-y: auto;
	top: 12.5vh;
	left: 12.5vw;
	background-color: #FFF;
	padding: 1rem;

	.sem-center {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		text-align: center;
	}
}

/* https://vuejs.org/guide/built-ins/transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
